<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-account-multiple-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Bus Stop</span>
      <span v-else>Edit Bus Stop </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="bus_location" attribute="fields.bus_location">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :items="busLocations"
                  item-text="start_point"
                  item-value="id"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.bus_location"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <form-group
              name="stop_point_name"
              :attribute="`fields.stop_point_name`"
            >
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.stop_point_name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <v-dialog
              ref="dialog2"
              v-model="stopTime"
              :return-value.sync="form.stop_time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <form-group name="stop_time" :attribute="`fields.stop_time`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners && on"
                      v-model="form.stop_time"
                      label="Stop Time"
                      readonly
                    ></v-text-field>
                  </template>
                </form-group>
              </template>
              <v-time-picker
                v-if="stopTime"
                v-model="form.stop_time"
                full-width
                use-seconds
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="stopTime = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog2.save(form.stop_time)"
                  >OK</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <v-dialog
              ref="dialog"
              v-model="returnTime"
              :return-value.sync="form.return_time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <form-group
                  name="return_time"
                  :attribute="`fields.return_time`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners && on"
                      v-model="form.return_time"
                      label="Return Time"
                      readonly
                    ></v-text-field>
                  </template>
                </form-group>
              </template>
              <v-time-picker
                v-if="returnTime"
                v-model="form.return_time"
                full-width
                use-seconds
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="returnTime = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(form.return_time)"
                  >OK</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="6">
            <form-group name="longitude" :attribute="`fields.longitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.longitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="6">
            <form-group name="latitude" :attribute="`fields.latitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.latitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import {
  required,
  decimal,
  minValue,
  maxValue,
  maxLength
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      busLocations: [],
      form: {
        bus_location: "",
        stop_point_name: "",
        stop_time: "",
        return_time: "",
        latitude: ""
      },
      // time: null,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null
    };
  },
  created() {
    this.editCreateBoolean();
    this.indexBusLocations();
  },
  methods: {
    indexBusLocations() {
      IndexData({ reqName: "bus-locations" })
        .then(res => {
          const { data } = res.data;
          this.busLocations = data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createBusStop();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `bus-stops`,
        id: id
      })
        .then(res => {
          const { bus_stop } = res.data;
          this.form = bus_stop;
        })
        .catch(() => {});
    },
    createBusStop() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `bus-stops`,
        data: formData
      })
        .then(() => {
          this.$router.push("/bus-stops");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (formItem === "bus_location" || formItem == null) {
          return;
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `bus-stops`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/bus-stops");

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "busStopEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      stop_point_name: {
        required,
        maxLength: maxLength(190)
      },
      stop_time: {
        required
      },
      return_time: {
        required
      },
      latitude: {
        decimal,
        minValue: minValue(-90),
        maxValue: maxValue(90)
      },
      longitude: {
        decimal,
        minValue: minValue(-180),
        maxValue: maxValue(180)
      }
    }
  }
};
</script>
